import { render, staticRenderFns } from "./InfoDetail.vue?vue&type=template&id=4a6eda94&"
import script from "./InfoDetail.vue?vue&type=script&lang=js&"
export * from "./InfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./InfoDetail.vue?vue&type=style&index=0&id=4a6eda94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports